export const getA11yIDs = (code: string) => ({
  headerID: `panel${code}-header`,
  contentID: `panel${code}-content`,
});
